import ImagesPinsPresenter from "./../components/images-pins/presenter/images-pins.js";

const imagesPinsContainer = document.querySelector(`.images-pins-list`);
const imagesPinsComponent = new ImagesPinsPresenter(imagesPinsContainer);

imagesPinsComponent.init();
